module.exports = __webpack_public_path__ + "images/emoji/department_store.d93cc8f43be76c9e4043.png";